import { type EnvironmentId } from "@cmmd-forge/contracts";
import { type QueryClient } from "@tanstack/react-query";

export type EnvironmentEventDependencies = {
  readonly notifyProviderInvalidation: () => void;
  readonly readQueryClient: () => Pick<QueryClient, "invalidateQueries"> | null;
  readonly setRuntimeError: (environmentId: EnvironmentId, error: unknown) => void;
};

let dependencies: EnvironmentEventDependencies | null = null;

export function configureEnvironmentEventDependencies(next: EnvironmentEventDependencies): void {
  dependencies = next;
}

export function readEnvironmentEventDependencies(): EnvironmentEventDependencies {
  if (dependencies === null) {
    throw new Error("Environment event handling was used before the service was configured.");
  }
  return dependencies;
}
